import { Utils } from 'common';

const { Communication } = Utils;

export default class HistoryCommunication extends Communication {
	static init(params) {
		Communication.init(params);
	}

	// TODO, Update when Backend is ready for /r/swsim
	static swsimUrl = '/accountapi/r/swsim/v1/';

	static getPrints = data =>
		this.axiosRequestWithBigInt({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/reports/v1/prints`,
			timeout: 45000,
			data,
		});

	static submitMailInRefundRequest = universalId =>
		// TODO: Replace the correct URL path once SERA API URL is available
		this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/netstamps/${universalId}/void`,
		});

	/**
	 * @param {string} labelId
	 * @return {object}
	 * Void single label (e-refund only)
	 */
	static submitERefundRequest = labelId =>
		this.axiosRequest({
			method: 'put',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/labels/${labelId}/void`,
		});

	/**
	 * @param {object} data
	 * @return {object}
	 * Void one or more labels (mail-in or e-refund by list of labelID, and/or Netstamps by list of universalPostageIds)
	 */
	static submitRefund(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/labels/void`,
			data,
		});
	}

	/**
	 * @param {object} data
	 * @return {object}
	 */
	static createManifest(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/manifests`,
			data,
		});
	}

	/**
	 * @param {string} scope - domestic or international
	 * @return {object}
	 */
	static createManifestDHLeC(scope) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/manifests/drivers-manifests/${scope}`,
			data: {
				label_options: {
					label_format: 'pdf',
					label_output_type: 'url',
				},
			},
		});
	}

	/**
	 * @param {string} scope - domestic or international
	 * @return {object}
	 */
	static getPrintedManifestsDHLeC(scope) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/manifests/drivers-manifests/${scope}?recent_days=14`,
		});
	}

	/**
	 * @param {string} manifestId
	 * @return {object}
	 */
	static reprintManifestDHLeC(manifestId) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/manifests/drivers-manifests/${manifestId}?label_output_type=url`,
		});
	}

	/**
	 * @param {string} scope
	 * @return {object}
	 */
	static getManifestCountDHLeC(scope) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/manifests/drivers-manifests/pending-count/${scope}`,
		});
	}

	static createContainerLabel(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/container-labels`,
			timeout: 50000,
			data,
		});
	}

	static reprintContainerLabel = labelId =>
		this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/labels/${labelId}?label_output_type=url?label_format=png`,
		});

	/**
	 * @param {object} data
	 * @return {object}
	 */
	static saveManifest(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/print/manifests`,
			data,
		});
	}

	/**
	 * @param {object}
	 * @returns {array}
	 */
	static loadManifests() {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/print/manifests/`,
		});
	}

	/**
	 * @param {object} data
	 * @return {object}
	 */
	static setCostCode(data) {
		return this.axiosRequest({
			method: 'put',
			url: `${this.accountApiUrlPrefix}/print/costcode`,
			data,
		});
	}

	/**
	 * @param {object}
	 * @returns {array}
	 */
	static getTrackingDetails({ carrier, trackingNumber }) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/tracking/v1/tracking?carrier=${carrier}&tracking_number=${trackingNumber}`,
		});
	}

	/**
	 * @param {object}
	 * @returns {array}
	 */
	static schedulePickup(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/pickups/`,
			data,
		});
	}

	/**
	 * @param {string} labelId
	 * @return {object}
	 */
	static getLabelAndOrderDetails(labelId) {
		return this.axiosRequestWithBigInt({
			url: `${this.accountApiUrlPrefix}/r/reports/v1/labels/${labelId}`,
		});
	}

	/**
	 * @param {string} labelId
	 * @return {object}
	 */
	static getLabelDetails(labelId) {
		return this.axiosRequestWithBigInt({
			url: `${this.accountApiUrlPrefix}/r/reports/v2/labels/${labelId}`,
		});
	}

	/**
	 * @returns {array}
	 */
	static getSchedulePickup() {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/pickups`,
		});
	}

	/**
	 * @param {string} pickupId
	 * @returns {array}
	 */
	static deleteSchedulePickup(pickupId) {
		return this.axiosRequest({
			method: 'delete',
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/pickups/${pickupId}`,
		});
	}

	/**
	 * @param {object}
	 * @return {object}
	 */
	static getLabelReprint(data) {
		return this.axiosRequest({
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/labels/${data.labelId}?label_size=${data.labelSize}&label_format=${data.labelFormat}&label_output_type=${data.labelOutputType}`,
		});
	}

	/**
	 * @param {object}
	 * @return {object}
	 */
	static getNetstampsReprint(data) {
		return this.axiosRequest({
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/netstamps/${data.labelId}?label_format=${data.labelFormat}&label_output_type=${data.labelOutputType}&start_row=${data.startRow}&start_column=${data.startColumn}&serial_number=${data.serialNumber}&print_layout=${data.printLayout}`,
		});
	}

	/**
	 * @param {object}
	 * @return {object}
	 */
	static getEnvelopeReprint(data) {
		return this.axiosRequest({
			url: `${this.accountApiUrlPrefix}/r/swsim/v1/envelopes/${data.labelId}?envelope_type=${data.envelopeType}&label_format=${data.labelFormat}&label_output_type=${data.labelOutputType}`,
		});
	}

	/**
	 * @param {object}
	 * @return {object}
	 */
	static excludeAutorefundAssist(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/r/sera/v1/autorefundoptout`,
			data,
		});
	}
}
